import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
} from '@chakra-ui/react';
import { FC, useState } from 'react';

export enum HideIssueType {
  FOLDER = 'FOLDER',
  DOCUMENT = 'DOCUMENT',
}

interface HideIssueModalProps {
  isOpen: boolean;
  onClose: () => void;
  issueType: HideIssueType;
  onSubmit: (message: string) => void | Promise<void>;
  isLoading?: boolean;
}

export const HideIssueModal: FC<HideIssueModalProps> = ({
  isOpen,
  onClose,
  issueType,
  onSubmit,
  isLoading = false,
}) => {
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    await onSubmit(message);
    handleClose();
  };

  const handleClose = () => {
    setMessage('');
    onClose();
  };

  const modalTitle =
    issueType === HideIssueType.FOLDER
      ? 'Hide Folder Issue'
      : 'Hide Document Issue';

  return (
    <Modal isOpen={isOpen} size="md" onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{modalTitle}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel>Reason for hiding (optional)</FormLabel>
            <Textarea
              placeholder={`Why are you hiding this ${issueType.toLowerCase()} issue?`}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button mr={3} variant="ghost" onClick={handleClose}>
            Cancel
          </Button>
          <Button isLoading={isLoading} onClick={() => void handleSubmit()}>
            Hide Issue
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
